import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Navigate } from "react-router-dom";
import { AUTH_CHALLENGES } from "@/constants/auth";
import { useAuth } from "@/context/auth/AuthContext";
import { LOGIN_PAGE } from "./paths";
/**
 * Route guard for MFA setup page.
 * Allows access for MFA_SETUP challenges or org-enforced setup.
 */ export default function MfaSetupRoute({ children }) {
    const { challengeData, initialized, isLoading, mfaSetupRequired } = useAuth();
    // Wait for auth to initialize before making redirect decisions
    if (!initialized || isLoading) {
        return null;
    }
    // Allow org-enforced MFA setup for authenticated users
    if (mfaSetupRequired) {
        return /*#__PURE__*/ _jsx(_Fragment, {
            children: children
        });
    }
    // Allow challenge-based MFA setup
    if (challengeData?.challengeName === AUTH_CHALLENGES.MFA_SETUP) {
        return /*#__PURE__*/ _jsx(_Fragment, {
            children: children
        });
    }
    // Otherwise, redirect to login
    return /*#__PURE__*/ _jsx(Navigate, {
        to: LOGIN_PAGE,
        replace: true
    });
}
